import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { BusinessBuilderRandomIdeasCollection } from './business-builder-random-ideas.types';

export function businessBuilderRandomIdeasBackend(): Backend<BusinessBuilderRandomIdeasCollection> {
  return {
    defaultOrder: {
      field: 'titleLength',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query) => {
      const [count] = getQueryParamValue(query, 'count');
      const [excludeBlueprintUuids] = getQueryParamValue(
        query,
        'excludeBlueprintUuids',
      );

      return {
        endpoint: 'business-builder/templates-random.php',
        method: 'GET',
        isGaf: true,
        params: {
          count: count ?? 4,
          excludeBlueprintUuids:
            excludeBlueprintUuids && excludeBlueprintUuids.length > 0
              ? excludeBlueprintUuids
              : undefined,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
